module.exports = __webpack_public_path__ + "assets/img/contact-s.0e5085a4.png";